import * as React from "react"
import { RequestParameters } from "components/Shared/Filters/interfaces"
import { validateFilters } from "components/Shared/Filters/hooks/useValidateFilters"
import { FiltersDataMessage } from "components/Shared/Filters/FiltersDataMessage"
import mandatoryFilters from "./SwitchingValidatorConfig"

type SwitchingInputValidatorProps = {
	switchingFilters: RequestParameters
}

const SwitchingInputValidator: React.FC<SwitchingInputValidatorProps> = (
	props
) => {
	const { children, switchingFilters } = props
	const error = validateFilters(switchingFilters, mandatoryFilters)

	if (error) {
		return (
			<FiltersDataMessage
				title={
					"phronesis.performance.application.switching.filtermessage.title"
				}
				description={
					"phronesis.performance.application.switching.filtermessage.text"
				}
			/>
		)
	}

	return <>{children}</>
}

export default SwitchingInputValidator
